module.exports = __webpack_public_path__ + "img/culture1Hover.07b5518e.jpg";